<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_xiii"></a><em>Have I betrayed them all again by telling the story?</em></p>
<p class="fm"><em>Or is it the other way round:</em></p>
<p class="fm"><em>would I have betrayed them if I had not told it?</em></p>
<p class="fm">—AMOS OZ</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?1cad9b13